import gql from "graphql-tag.macro";

const v3CreateProjectMutation = gql`
    mutation createProject($parentId: ObjectID!, $legacyId: ID, $projectName: String!) {
        createProjectInInstance(parentId: $parentId, input: { name: $projectName, legacyId: $legacyId, description: $projectName, disabled: false }) {
            _id
            name
            description
        }
    }
`;

const loadCurrentUserQuery = gql`
    query me {
        me(forceRefresh: true) {
            _id
            username
            firstname
            lastname
            email
        }
    }
`;

const loadGroupsByProjectQuery = gql`
    query loadGroupsByProject($projectId: ID!) {
        groupsByProject(projectId: $projectId) {
            id
            name
            path
        }
    }
`;

const rolloverUsersToProjectMutation = gql`
    mutation rolloverUsersToProject($specialCase: [UserRolloverSpecialCase!]!, $toProject: String!) {
        rolloverUsersInProject(clients: [], fromProject: "", toProject: $toProject, specialCase: $specialCase) {
            client
            email
            status
            remarks
            userId
            instanceId
            fromProjectId
            toProjectId
        }
    }
`;

export const rolloverUsersToProject = async ({ toProject, users }, { client }) => {
    const { data: { rolloverUsersToProject: data } = {} } = await client.mutate({
        mutation: rolloverUsersToProjectMutation,
        variables: {
            toProject,
            specialCase: [{ client: window.location.hostname, users }],
        },
    });
    return data;
};

export const v2CreateProject = async ({ projectName, projectOrganisation }, {}) => {
    if (window?.APPVERSION?.directory) {
        const { success, ID, message } = await window.app.Duchess.createProject(projectName, projectOrganisation);
        if (success) {
            return {
                projectId: ID,
            };
        } else throw new Error(message);
    }
};

export const loadCurrentUser = async ({ client }) => {
    const {
        data: { me: data },
    } = await client.query({
        query: loadCurrentUserQuery,
        variables: {},
        fetchPolicy: "no-cache",
    });
    return data;
};

export const loadGroupsByProject = async ({ projectId }, { client }) => {
    const {
        data: { groupsByProject: data },
    } = await client.query({
        query: loadGroupsByProjectQuery,
        variables: {
            projectId,
        },
        fetchPolicy: "no-cache",
    });
    return data || [];
};

export const v3CreateProject = async ({ legacyId, parentId, projectName }, { client }) => {
    const { data: { createProjectInInstance: data } = {} } = await client.mutate({
        mutation: v3CreateProjectMutation,
        variables: { legacyId, parentId, projectName },
    });
    return data;
};
